export const addoncars = [
  {
    id: Math.random(),
    name: "じこ : BMW E30",
    url: "https://img.gta5-mods.com/q95/images/bmw-m3-e30-1990-add-on-tuning-template/398d20-81.jpg",
    accel: "87%",
    tops: "86%",
    grip: "86%",
    cat: "S+",
    colorC: "blue",
    avail: "Exclusive",
    colorAv: "RED",
    vid: "https://www.youtube.com/embed/KJ2CuReNKG4",
    ees: true,
    addon: true,
    exc: true,
    desc: "The BMW E30 is the second generation of BMW 3 Series, which was produced from 1982 to 1994 and replaced the E21 3 Series. The model range included 2-door coupe and convertible body styles, as well as being the first 3 Series to be produced in 4-door sedan and wagon/estate body styles.",
  },

  {
    id: Math.random(),
    name: "じこ : PULSAR GTI-R",
    url: "https://www.gtav.hachiraito.com/wp-content/uploads/2022/03/pulsar-cover-scaled.jpg",
    accel: "85%",
    tops: "85%",
    grip: "88%",
    cat: "S+",
    colorC: "blue",
    avail: "Exclusive",
    colorAv: "RED",
    vid: "https://www.youtube.com/embed/F5m1C7-MZfE",
    ees: true,
    addon: true,
    exc: true,
    desc: "Produced from 1990-1994, the Nissan Pulsar GTI-R came with an SR20DET that put out 277hp and 210 lb-ft of torque. Since it only weighed 2,400 lbs, this was more than enough to give it a 0-60 of five seconds, around the same as a Porsche 911 of the",
  },
  {
    id: Math.random(),
    name: "じこ : INTEGRA DC5",
    url: "https://img.gta5-mods.com/q95/images/honda-integra-type-r-dc5-j-s-racing-mugen-ings-1/a5de90-20180920235622_1.jpg",
    accel: "86%",
    tops: "86%",
    grip: "83%",
    cat: "S+",
    colorC: "blue",
    avail: "Exclusive",
    colorAv: "RED",
    vid: "https://www.youtube.com/embed/mqe0t93TPfk",
    ees: true,
    addon: true,
    exc: true,
    desc: "The fourth-generation Honda Integra (chassis code DC5), produced by Honda, was introduced in Japan on 13 April 2001, and produced from July 2001 until August 2006. It was introduced in North America on 2 July 2001[2] as the Acura RSX, the name a part of Acura's naming scheme changing the names of its models from recognizable names like Integra or Legend to alphabetical designations in order for buyers to build more recognition to the marque, and not the individual cars.",
  },
  {
    id: Math.random(),
    name: "CHAWA : SKYLINE R32",
    url: "https://img.gta5-mods.com/q95/images/nissan-bnr-r32-pandem-add-on/4313dc-04.jpg",
    accel: "86%",
    tops: "84%",
    grip: "87%",
    cat: "S+",
    colorC: "blue",
    avail: "Exclusive",
    colorAv: "RED",
    vid: "https://www.youtube.com/embed/_cH3HDqk95Y",
    ees: true,
    addon: true,
    exc: true,
    desc: "The R32 Skyline GT-R had all-wheel drive and the famed Nissan RB26DETT inline six engine that pumped out 280 horsepower. It still wasn't sold in America, but the JDM (Japanese Domestic Market) model was and still is a legend in the American tuner community.",
  },
  {
    id: Math.random(),
    name: "WASSIM : 2017 RAPTOR",
    url: "https://img.gta5-mods.com/q95/images/2017-ford-raptor-hq-rigged-suspension-multi-dirt-animated-engine-tuning/3099bd-main.png",
    accel: "78%",
    tops: "75%",
    grip: "83%",
    cat: "S+ Offroad",
    colorC: "blue",
    avail: "Exclusive",
    colorAv: "RED",
    vid: "https://www.youtube.com/embed/5ShOEDOCcbI",
    ees: true,
    addon: true,
    exc: true,
    ban: true,
    desc: "All new for 2017, the Raptor is based on the current Ford F-150, but the dedicated off-roader is 6.4 inches wider and flaunts unique styling and exclusive equipment. Along with an aluminum bed and body, the Raptor has a twin-turbo V-6 and a 10-speed automatic.",
  },
  {
    id: Math.random(),
    name: "Titanium : GTR35",
    url: "https://img.gta5-mods.com/q95/images/2015-nissan-gtr-nismo-yca-y97y/6b4837-6.jpg",
    accel: "85%",
    tops: "87%",
    grip: "86%",
    cat: "S+",
    colorC: "blue",
    avail: "Exclusive",
    colorAv: "RED",
    vid: "https://www.youtube.com/embed/cqoD8XYh84U",
    ees: true,
    addon: true,
    exc: true,
    desc: "The Nissan GT-R (Gran Turismo–Racing; model code: R35; Japanese: 日産・GT-R; Nissan GT-R) is a car built by Japanese marque Nissan since 2007. It has a 2+2 seating layout and is considered both a sports car and a grand tourer. The engine is front-mid mounted and drives all four wheels.",
  },
  {
    id: Math.random(),
    name: "Nasty : S15",
    url: "https://cache-tr.zonerama.com/photos/public/431826949_1338x639_16.jpg?eQnhSL76%2BdfHebLAa69JP1ZUrogVSA7hvver44P6eizgB6zy%2Fhil4UiLFC3lumFbbN18k7KI0dqwuuUMZXA7Ed2SVOSOczh8eF8AUucHN3dhe2vUbQY10%2BaOMQHR1Pe33HeEg%2Bgslg6s%2FVeojrsAH%2Bjpgb5u4fj2T8Xy%2BP7F3kV0QTQ2UB28%2BR0l0NSRLh0i",
    accel: "86%",
    tops: "86%",
    grip: "86%",
    cat: "S+",
    colorC: "blue",
    avail: "Exclusive",
    colorAv: "RED",
    vid: "https://www.youtube.com/embed/Zf2z3WIxio0",
    ees: true,
    addon: true,
    exc: true,
    desc: "The S15 arrived in 1999 with a remarkable 247bhp at 6,400rpm and 203 ft/lb torque from the most powerful inline-four SR20DET to date. The additional power was mostly due to a ball-bearing update in the turbocharger and engine management changes.",
  },
  {
    id: Math.random(),
    name: "Rico : BMW E36",
    url: "https://img.gta5-mods.com/q95/images/bmw-m3-e36-streetcustom-add-on-tuning/05b27d-20161009013425_1.jpg",
    accel: "87%",
    tops: "86%",
    grip: "85%",
    cat: "S+",
    colorC: "blue",
    avail: "Exclusive",
    colorAv: "RED",
    vid: "https://www.youtube.com/embed/HHuYz05i6JU",
    ees: true,
    addon: true,
    exc: true,
    desc: "The E36 was the first 3 Series to be offered in a hatchback body style. It was also the first 3 Series to be available with a six-speed manual transmission (in the 1996 M3), a five-speed automatic transmission, and a four-cylinder diesel engine.",
  },
  {
    id: Math.random(),
    name: "Sabowww : F40",
    url: "https://c10.patreonusercontent.com/4/patreon-media/p/post/38201922/c4bee4e33d504823a50c78233de1ffb8/eyJxIjoxMDAsIndlYnAiOjB9/1.jpg?token-time=1706227200&token-hash=oFicVxo69HvDtg4xmfzC6ZJrdaVIAmFFzP-lMnNStWE%3D",
    accel: "88%",
    tops: "89%",
    grip: "79%",
    cat: "S+",
    colorC: "blue",
    avail: "Exclusive",
    colorAv: "RED",
    vid: "https://www.youtube.com/embed/_msTssdiKOM",
    ees: true,
    addon: true,
    exc: true,
    desc: "The Ferrari F40 (Type F120) is a mid-engine, rear-wheel drive sports car engineered by Nicola Materazzi with styling by Pininfarina. It was built from 1987 until 1992, with the LM and GTE race car versions continuing production until 1994 and 1996 respectively.",
  },
  {
    id: Math.random(),
    name: "DIP : GT86",
    url: "https://www.gtav.hachiraito.com/wp-content/uploads/2021/06/gt86k-cover-scaled.jpg",
    accel: "86%",
    tops: "85%",
    grip: "86%",
    cat: "S+",
    colorC: "blue",
    avail: "Exclusive",
    colorAv: "RED",
    vid: "https://www.youtube.com/embed/_cH3HDqk95Y",
    ees: true,
    addon: true,
    exc: true,
    desc: "The Toyota 86 and the Subaru BRZ are 2+2 sports cars jointly developed by Toyota and Subaru, manufactured at Subaru's Gunma assembly plant. The 2+2 fastback coupé has a naturally-aspirated boxer engine, front-engined, rear-wheel-drive configuration, 53/47 front/rear weight balance and low centre of gravity; it was inspired by Toyota's earlier AE86, a small, light, front-engine/rear-drive Corolla variant widely popular for Showroom Stock, Group A, Group N, Rally, Club and drift racing.",
  },
  {
    id: Math.random(),
    name: "PORSCHE 911 GT3",
    url: "https://cache-tr.zonerama.com/photos/public/432919192_1209x638_16.jpg?lzGYrBHdhgsYxBUW18V3LbQL8ay%2FGD1TnktjKKY2rcegcIPiQdHSEChRd4BWkT%2Bd9rHE0OpTT4CaYAu4LP3U52w%2BkovQYp4Ge6P5HrZsx13K%2F47vEoQoGi2i4YUj9MbutsErM2uVgJ2zK7ZUJYkG5PKHlBtyMmst3Nmi3YEFqbAcrYZG0VGL5jNco1CQ0pGw",
    accel: "85%",
    tops: "84%",
    grip: "87%",
    cat: "S+",
    colorC: "blue",
    avail: "DS SHOP",
    colorAv: "GREEN",
    vid: "https://www.youtube.com/embed/mHErjcfSTfI",
    ees: true,
    addon: true,
    exc: false,
    desc: "The 991 GT3 features a new 3.8 litre multi-point electronic indirect injection flat-six engine developing 475 PS (469 hp; 349 kW) at 8,250 rpm, a Porsche Doppelkupplung (PDK) double-clutch gearbox and rear-wheel steering. The engine is based on the unit fitted in the 991 Carrera S, but shares only a few common parts.",
  },
  {
    id: Math.random(),
    name: "MERCEDES CLS19 ME",
    url: "https://cache-tr.zonerama.com/photos/public/432920476_1298x638_16.jpg?NMDu1XOjmdQAfqjJpIi7lF%2F%2BLixHzalZ9hvhdzhqYOC5qHviHkKNCYg%2BdlW210GhLQyf6LneJ%2F96CmzrUdZvcql1hnwSZ1eZLgU6YgQ28DjGWpgqfkkNeY0l5FLBGcLvM8QQjMrIa5z7Z4tquXDqaxzgzNFQZp1j0dwC%2FWAWZ5Zh9plLiCf0Va6hCNfDik%2Fw",
    accel: "86%",
    tops: "85%",
    grip: "85%",
    cat: "S+",
    colorC: "blue",
    avail: "DS SHOP",
    colorAv: "GREEN",
    vid: "https://www.youtube.com/embed/2z7tZGS8GmE",
    ees: true,
    addon: true,
    exc: false,
    desc: "The Mercedes-Benz CLS (initially called the CLS-Class) is a series of executive cars produced by Mercedes-Benz from 2004 to August 2023. The original model was a four-door sedan based on the Mercedes E-Class platform, marketed as a four door coupé. An estate (shooting brake) model was later added to the model range with the second generation CLS. All models are available as a high performance AMG variant, although it wasn't until the second generation CLS that 4MATIC all-wheel drive was offered.",
  },
  {
    id: Math.random(),
    name: "AMG BLACKSERIES",
    url: "https://cache-tr.zonerama.com/photos/public/433048383_1207x638_16.jpg?svUsn6%2FfR6Z2xihdOhqX1f%2FnHcOKHF6k0unV0KSYd%2BoRB4th8mIkBQkqh%2BSD7wtK2CP%2FXGxHj4eety766%2B9Sl1weFt7%2B5MFJxd%2Bn1hJbTTc%2F5m3HSGk8Hp4eDFKXnRDbZOovZNIcSpwysBk6NJxkGWIXmwwBXrETM4qOXvc1qhR%2Fhg2jHZSOBiGGDgTlYW2%2B",
    accel: "87%",
    tops: "86%",
    grip: "83%",
    cat: "S+",
    colorC: "blue",
    avail: "DS SHOP",
    colorAv: "GREEN",
    vid: "https://www.youtube.com/embed/suYDTQYHsoM",
    ees: true,
    addon: true,
    exc: false,
    desc: "At the core of the AMG GT Black Series is a handcrafted 4.0-liter V8 engine that roars to life with an astonishing 720 horsepower and 590 lb-ft of torque.",
  },
  {
    id: Math.random(),
    name: "MUSTANG GT500 LW",
    url: "https://cache-tr.zonerama.com/photos/public/433050579_1199x638_16.jpg?AxbIQ4akLAyw%2B1m%2Ffa7vgk00Bssx%2B9Q7qBmh7avSlHyv7UL6CPCyBK71gead4z1PEcvW1aau%2BdNYxaUo0pzwPC40Ip0TDbxsyNrSa0Tldn%2F%2BgMON%2FZ2jnvbNAZoYjY3%2FM6meexdG%2B%2BfNT8IP2azueejIZYU7DmhUP9E7jZJEQFHbgdxU1eJreMQlJScVHprp",
    accel: "86%",
    tops: "85%",
    grip: "85%",
    cat: "S+",
    colorC: "blue",
    avail: "DS SHOP",
    colorAv: "GREEN",
    vid: "https://www.youtube.com/embed/xdDrkV4LU8w",
    ees: true,
    addon: true,
    exc: false,
    desc: "Aptly called Predator, the motor is a supercharged 5.2-liter V-8 that summons 760 horsepower and 625 pound-feet of torque.",
  },
  {
    id: Math.random(),
    name: "MUSTANG BOSS69",
    url: "https://img.gta5-mods.com/q75/images/1969-ford-mustang-boss-426/f44e25-07%20-%20pEveB8G.jpg",
    accel: "87%",
    tops: "84%",
    grip: "85%",
    cat: "S+",
    colorC: "blue",
    avail: "DS SHOP",
    colorAv: "GREEN",
    vid: "https://www.youtube.com/embed/OSVaAhvPjXc",
    ees: true,
    addon: true,
    exc: false,
    desc: "This car is one of the most sought-after Classic Recreations masterpieces. The original 1969 Ford Mustang Boss 429 was powered by a 7.0L V8 engine capable of generating 375 horsepower. ",
  },
];
